import { DITypes } from "@/core/@types/types";
import { type HttpClient } from "@/core/services/protocols/types";
import { inject, injectable } from "inversify";
import { IContaResponseData, PluggyGateway } from "../ports/PluggyGateway";
import { type IToastNotification } from "@/composables/shared/notification/types";
import { IContasResponseFin, IDefaultResponse } from "../types";

@injectable()
export default class PluggyGatewayAdapter implements PluggyGateway {
  @inject(DITypes.FINANCAS_HTTP_CLIENT)
  private httpClient!: HttpClient;

  @inject(DITypes.NOTIFICATION)
  private notification!: IToastNotification<string>;

  async obterConnectToken(id?: string | null): Promise<string | undefined> {
    const response = await this.httpClient?.get<IDefaultResponse>({
      url: "ContaAPI/GetPluggyConnectToken",
      queryParams: { itemId: id }
    });

    if (!response?.body?.Ok) return undefined;

    return response.body?.Result || undefined;
  }

  async obterConnectorId(id: string): Promise<number | undefined> {
    const response = await this.httpClient?.get<IDefaultResponse>({
      url: "ContaAPI/GetPluggyBankId",
      queryParams: { bancoId: id }
    });

    if (!response?.body?.Ok) {
      this.notification.showNotification(
        "O Open Finance não fornece serviço para o banco selecionado.",
        {
          type: "info",
          timeout: 3000
        }
      );

      return undefined;
    }

    const hasBancoId = response.body.Result;

    if (hasBancoId) {
      return Number(hasBancoId);
    } else {
      return undefined;
    }
  }

  async obterConta(id: string): Promise<IContasResponseFin | undefined> {
    const response = await this.httpClient?.get<IContaResponseData>({
      url: `/ContaAPI/Get/${id}`
    });

    if (!response?.body?.Ok) return;

    return response.body.Result;
  }

  async connectOpenFinanceByAccount(id: string): Promise<boolean> {
    const response = await this.httpClient?.post<IDefaultResponse>({
      url: "/WebserviceAPI/ConnectOpenFinanceByAccount",
      body: {
        contaId: id
      }
    });

    if (!response.body?.Ok) return false;

    this.notification.showNotification("Conexão Realizada com Sucesso!", {
      type: "success",
      timeout: 3000
    });

    return true;
  }
}
